export default __webpack_public_path__ + "static/media/cp_geo_tg.1b41a405.svg";